import { createWebHistory, createRouter } from "vue-router";

import Portfolio from '../views/Portfolio';
import NotFound from '../views/NotFound';

const routes = [
    {
        path: "/:type_of_work?/:sector?/:client?",
        name: "Home",
        component: Portfolio,
        // props: (route) => ({
        //     type_of_work: route.params.type_of_work || 'default',
        //     sector: route.params.sector || 'default'
        // }),
        meta: {
            title: 'The Lane Agency Portfolio',
            metaTags: [
                {
                    name: 'description',
                    content: ''
                },
                {
                    property: 'og:description',
                    content: ''
                }
            ]
        }
    }
    //,
    // {
    //     path: "/simulator/:class?/:event?/:session?",
    //     name: "Simulator",
    //     component: TimingScreen,
    //     meta: {
    //         title: 'Simulator',
    //         metaTags: [
    //             {
    //                 name: 'description',
    //                 content: 'Free live timing screen for all MotoGP, Moto2, Moto3 and MotoE sessions throughout the year.'
    //             },
    //             {
    //                 property: 'og:description',
    //                 content: 'Free live timing screen for all MotoGP, Moto2, Moto3 and MotoE sessions throughout the year.'
    //             }
    //         ]
    //     }
    // },
    // {
    //     path: "/:catchAll(.*)",
    //     name: 'notfound',
    //     component: NotFound
    // }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {

    if (to.name === 'notfound') {
        window.location.href = '/not-found';
    }

    // This goes through the matched routes from last to first, finding the closest route with a title.
    // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
    // `/nested`'s will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if(nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    } else if(previousNearestWithMeta) {
        document.title = previousNearestWithMeta.meta.title;
    }

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if(!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    // Track a new Matomo page view
    // if (from.href) {
    //     _paq.push(['setReferrerUrl', from.href]);
    //     _paq.push(['setCustomUrl', to.href]);
    //     _paq.push(['setDocumentTitle', document.title]);
    //     _paq.push(['trackPageView']);
    // }

    next();
});

export default router;
